import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import { FormsContainer } from '../../components/forms/FormsContainer';

const FormsPage: React.FC = () => {
  const navigate = useNavigate();
  const { me } = useAuth();

  useEffect(() => {
    if (!me) return;
    if (!me?.isSuperuser && !me?.role?.viewCMS) navigate('/');
  }, [me, me?.isSuperuser, me?.role?.viewCMS, navigate])

  return (
    <Box>
      <FormsContainer />
    </Box>
  );
};

export default FormsPage;
